import { BodyMutationObserver } from "./body-mutation-observer";

describe("BodyMutationObserver", () => {
    let mutationCallback;
    let observeSpy;
    const mockMutationRecords = [
        {
            type: "attributes",
            attributeName: "class"
        }
    ];

    beforeEach(() => {
        // @ts-ignore
        global.MutationObserver = class {
            constructor(callback) {
                mutationCallback = callback;
            }
            disconnect() {}
            observe(
                /* eslint-disable-next-line */ // @ts-ignore
                element,
                /* eslint-disable-next-line */ // @ts-ignore
                initObject
            ) {}
        };

        document.body = document.createElement("body");
        /* eslint-disable-next-line */
        observeSpy = jest.spyOn(BodyMutationObserver.prototype as any, "observeBody");
        // @ts-ignore Set initial state without theme
        window.trumpf = { ux: { theme: "" } };
    });

    afterEach(() => {
        observeSpy.mockRestore();
    });

    it('should change the theme to web when the body class contains "ux-theme-web"', () => {
        new BodyMutationObserver();

        document.body.className = "ux-theme-web";
        mutationCallback(mockMutationRecords);
        expect(window.trumpf.ux.theme).toBe("web");
    });

    it('should change the theme to responsive when the body class contains "ux-theme-responsive"', () => {
        new BodyMutationObserver();

        document.body.className = "ux-theme-responsive";
        mutationCallback(mockMutationRecords);
        expect(window.trumpf.ux.theme).toBe("responsive");
    });

    it('should not change the theme when the body class contains neither "ux-theme-web" nor "ux-theme-responsive"', () => {
        new BodyMutationObserver();

        document.body.className = "other-theme";
        mutationCallback(mockMutationRecords);
        expect(window.trumpf.ux.theme).toBe("");
    });

    it("should dispatch a uxThemeChange event on the window when the theme changes", () => {
        const dispatchEventSpy = jest.spyOn(window, "dispatchEvent");
        new BodyMutationObserver();

        document.body.className = "ux-theme-web";
        mutationCallback(mockMutationRecords);

        expect(dispatchEventSpy).toHaveBeenCalled();
        const event = dispatchEventSpy.mock.calls[0][0] as Event;
        expect(event.type).toBe("uxThemeChange");
    });
});
